<template>
  <div class="content-wrapper" v-if="modalBehavior.showModalCategorySearch" ref="categoryContainer">

    <div class="content">
      <table class="w-100">
      <tbody>
        <tr>
          <th class="text text-center title" colspan="3">Document Type</th>
        </tr>
        <tr>
          <td class="text text-center subtitle" colspan="3">What type is your document?</td>
        </tr>
        <tr>
          <td><label>NOTE: Document type is optional if a procedure is selected on the next page.</label></td>
        </tr>
        <tr>
          <td><label for="desc">Ex. nurse note, office visit</label></td>
        </tr>
        <tr>
          <td class="w-50"><input id="desc" type="text" name="desc" v-model="categoryDesc" @keypress="pressToProceed" class="w-100"></td>
          <td><button type="button" class="btn btn--success" @click="handleSearchCategory">Search</button></td>
        </tr>
        <!--<tr v-if="modalCategorySearchWarning">-->
          <!--<td><small style="color:#ff4444">* Please search and select a category</small></td>-->
        <!--</tr>-->
      </tbody>
      </table>

      <!-- search results -->
      <ul class="list">
        <li class="list__item" v-if="!paginateData || paginateData.length < 1">
          <small style="color:#ff4444">No item to select from</small>
        </li>
        <li v-for="(category, index) in paginateData" :key="index" :value="category.ccd" class="list__item">
          <a class="list__link" :class="{selected:category.ccd===categorySelected}"
                  @click="selectCategory(category.ccd)">
            {{index+1}}. {{ category.desc }}
          </a>
        </li>
      </ul>
    </div>

    <!-- pagination-->
    <div v-if="categorySearchResults.length>0">
      <button :disabled="pageNumber === 0"
              @click="prevPage"
              class="btn btn-prev">
        Previous
      </button>

      <input type="text" v-model="currPageNumber" id="currentPageNumber" style="width: 30px"/>
      <label for="currentPageNumber">/{{pageCount}} <button @click="toPage(currPageNumber-1)" class="btn ml-2">Go</button></label>

      <button :disabled="pageNumber >= pageCount -1"
              @click="nextPage" class="btn btn-next">
        Next
      </button>
    </div>
      <select class='recents form-select' size="4">
        <option selected>Recent choices...</option>
      <!-- <div class='recents overflow-auto'> -->
        <option v-for="recent in recents" :key="recent" :value="recent" @click="selectCategory2(recent)">
        {{  describe(recent)}}
        </option>
      </select>
    <!-- footer -->
    <div class="modal-footer">
      <button type="button" class="btn btn-danger btn--cancel"
              @click="slideModalTo('main')">Go back</button>
      <button type="submit" class="btn btn--success" @click="slideModalTo('procedureSearch')">Continue</button>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {searchNpi, searchCategory} from '@/api/pdfApi';
import { h } from 'vue';

  export default {
    name: "SaveModalCategorySearch",
    props: {
      modalBehavior: Object,
    },
    data() {
      return {
        categoryDesc: '',
        categorySelected: '',
        categorySearchResults: [],
        modalCategorySearchWarning: false,
        pageNumber: 0,
        size: 5,
        currPageNumber: 1,
      }
    },
    computed: {
      pageCount: function () {
        let l = this.categorySearchResults.length;
        return Math.ceil(l / this.size);
      },
      paginateData: function () {
        let start = this.pageNumber * this.size, end = start + this.size;
        return this.categorySearchResults.slice(start, end);
      },
      ...mapGetters('login', {
        allData: 'getAllData'
      }),
      recents: function () {
        if(this.allData.recent.report.ctgry && this.allData.recent.report.ctgry.length > 0)
        {
          return this.allData.recent.report.ctgry;
        }
        else
          return [];
      }
    },
    methods: {
      describe(ccd) {
        return this.allData.ccds[ccd].desc;
      },
      slideModalTo(modal) {
        // go back anytime
        if (modal === 'main') {
          this.$emit('slideModalTo', modal);
        }
        // continue only if a category is selected, otherwise a warning
        else if (modal === 'procedureSearch') {
          // if (this.categorySelected) {
            this.$emit('slideModalTo', modal);
          // }
          // else {
            // this.modalCategorySearchWarning = true;
          // }
        }
      },
      handleSaveExtraction() {
        if (this.categorySelected) {
          this.$emit('handleSaveExtraction');
          this.$emit('close');
        }
        else {
          this.modalCategorySearchWarning = true;
        }
      },
      handleSearchCategory() {
        if (this.categoryDesc) {
          this.loader =  this.$loading.show({
            container: this.$refs.categoryContainer
          }, {
            after: () => h('div',{},`Searching "${this.categoryDesc}"...`)
          });
          searchCategory(this.categoryDesc)
              .then((categories) => {
                this.categorySearchResults = _.orderBy(categories, 'desc');
                this.currPageNumber = 1;
              })
              .catch((err) => {
                console.error(err);
              }).finally(() => {
                this.loader.hide();
                this.loader = null;
              });
        }
        else {
          this.modalCategorySearchWarning = true;
        }
      },
      selectCategory2(ccd) {
        this.$emit('selectCategory', ccd);
        this.$emit('slideModalTo','procedureSearch');
      },
      selectCategory(ccd) {
        this.categorySelected = ccd;
        this.$emit('selectCategory', ccd);
        this.$emit('slideModalTo','procedureSearch');
      },
      pressToProceed(event) {
        if (event.keyCode === 13) {
          this.handleSearchCategory();
        }
      },

      // pagination
      nextPage() {
        this.pageNumber++;
        this.currPageNumber = this.pageNumber+1;
      },
      prevPage() {
        this.pageNumber--;
        this.currPageNumber = this.pageNumber+1;
      },
      toPage(pageNumber) {
        this.pageNumber = pageNumber;
      },

    }

  }
</script>

<style scoped lang="scss">
  @import "../../../../stylesheets/modules/_extraction-save-modal";
  .recents option:hover {
    background-color: rgb(192,192,192);
  }
  .list {
    padding: 0;
  }
  .list__item {
    list-style-type: none;
    /*padding-bottom: 5px;*/
  }
  /* pagination */
  .btn-number {
    border: none;
    background-color: transparent;
    cursor: pointer;
    font-size: 0.75em;
  }
  .btn-prev, .btn-next {
    background-color: transparent;

    &:hover {
      background-color: transparent;
    }
  }
  .list__link {
    font-size: 0.85em;
    color: #0060ff !important;
    cursor: pointer;
    padding: 5px;

    &:hover {
      // text-decoration: underline !important;
      background: #0060ff;
      color: white !important;
    }
  }
  .selected {
    background: #0060ff;
    color: white !important;
    border-radius: 3px;
  }
</style>